import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const HelpIcon: React.FC<UnknownObject> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0002 20.1667C16.0628 20.1667 20.1668 16.0627 20.1668 11C20.1668 5.93743 16.0628 1.83337 11.0002 1.83337C5.93755 1.83337 1.8335 5.93743 1.8335 11C1.8335 16.0627 5.93755 20.1667 11.0002 20.1667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33252 8.25003C8.54803 7.6374 8.97341 7.1208 9.53331 6.79174C10.0932 6.46268 10.7515 6.34239 11.3916 6.45219C12.0317 6.56198 12.6123 6.89476 13.0305 7.3916C13.4487 7.88844 13.6777 8.51726 13.6767 9.1667C13.6767 11 10.9267 11.9167 10.9267 11.9167V13.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 15.5834H11.01"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
